import axios from 'axios';

import { API_URL } from '../config';

const URL_SEARCH_VEHICLE = `${API_URL}/appa-contract/draft`;
const URL_VEHICLE_USE_TYPES = `${API_URL}/vehicle-use-types`;
const URL_BANKS_LIST = `${API_URL}/banks`;

export const searchVehicle = (data, getEkengData = false) => axios.post(URL_SEARCH_VEHICLE, { ...data, getEkengData })
  .then((resp) => resp.data.result);

export const fetchVehicleUseTypes = () => axios.get(URL_VEHICLE_USE_TYPES)
  .then((resp) => resp.data.result);

export const getBM = (policyHolderId) => axios.get(`${API_URL}/vehicle-bm?policy_holder_id=${policyHolderId}`)
  .then((resp) => resp.data.result);

export const fetchBanksList = () => axios.get(URL_BANKS_LIST).then((resp) => resp.data.result);
